// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1b73j","content":"Consent_content__1FeIM","footer":"Consent_footer__k2uTo"};